/**
 * Basket import line module mutations.
 */
export default {
  /**
   * Replace the entities in the state.
   *
   * @param {Object} state
   * @param {Array} entities
   */
  SET_ENTITIES(state, { entities }) {
    state.entities = entities
  },
}
